// import { React } from 'react'
import { get } from './counts.actions.js'

const countsMiddleware = store => next => action => {

	// var regex = /([A-Z]*)_UPDATE_SUCCESS/g;
	// TODO: dynamically set types to listen to update success for
	const regex = /(TIMESHEET|CANDIDATE)_UPDATE_SUCCESS/g;

	if(regex.test(action.type)) {
		store.dispatch(get());
	}

  return next(action);
}

export default countsMiddleware;


// WEBPACK FOOTER //
// ./src/modules/counts/counts.middleware.js